<template>
<div class="background">
  <div class="login">
        <h4>Samsung Promotool</h4>
      <div class="login-inner">
        <h3>Inloggen</h3>
        <el-input type="text" v-model="email" auto-complete="off" placeholder="Email"></el-input>
        <el-input type="password" v-model="password" auto-complete="off" placeholder="Wachtwoord"></el-input>
        <el-button type="primary" v-on:click="signIn" @keyup.enter="signIn">Inloggen</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { firebase } from '../firebase-config.js'

  export default {
    name: 'login',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signIn: function() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('/')
          },
          (err) => {
            this.$notify.error({
              title: 'Error',
              message: err.message
            });
          }
        );
      }
    }
  }
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.background {
  background-color: #354052;
  height: 100%;
  width: 100%;
  position: relative;
}
  .login {
    margin-top: 40px;
    border-radius: 4px;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-70%);
  }
  .login-inner {
    background: #fff;
    width: 350px;
    margin: 0 auto;
    padding: 20px;
    box-shadow: 7px 10px 101px 0px rgba(0,0,0,0.15);
  }

  .el-input {
    margin-top: 10px;
  }
  
  input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 100%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// Login.vue?11432c1a